import { gql } from "@apollo/client";

// Address-only query/mutation kept for the legacy CardDetail flow.
export const GET_USER_ADDRESS = gql`
  query GetUserAddress($userId: uuid!) {
    users_by_pk(id: $userId) {
      id
      address_line1
      address_line2
      city
      state
      zip_code
      country
    }
  }
`;

export const UPDATE_USER_ADDRESS = gql`
  mutation UpdateUserAddress(
    $userId: uuid!
    $address_line1: String
    $address_line2: String
    $city: String
    $state: String
    $zip_code: String
    $country: String
  ) {
    update_users_by_pk(
      pk_columns: { id: $userId }
      _set: {
        address_line1: $address_line1
        address_line2: $address_line2
        city: $city
        state: $state
        zip_code: $zip_code
        country: $country
      }
    ) {
      id
      address_line1
      address_line2
      city
      state
      zip_code
      country
    }
  }
`;

// Full driver-profile view used by the /profile page.
// email + phone are read-only here (auth identifiers, not in the user role's
// update_permissions on the users table).
export const GET_USER_PROFILE = gql`
  query GetUserProfile($userId: uuid!) {
    users_by_pk(id: $userId) {
      id
      name
      email
      phone
      address_line1
      address_line2
      city
      state
      zip_code
      country
      dob
      ssn_last4
      physical_cards_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;

export const UPDATE_USER_PROFILE = gql`
  mutation UpdateUserProfile(
    $userId: uuid!
    $name: String!
    $address_line1: String
    $address_line2: String
    $city: String
    $state: String
    $zip_code: String
    $country: String
    $dob: date
    $ssn_last4: String
  ) {
    update_users_by_pk(
      pk_columns: { id: $userId }
      _set: {
        name: $name
        address_line1: $address_line1
        address_line2: $address_line2
        city: $city
        state: $state
        zip_code: $zip_code
        country: $country
        dob: $dob
        ssn_last4: $ssn_last4
      }
    ) {
      id
      name
      address_line1
      address_line2
      city
      state
      zip_code
      country
      dob
      ssn_last4
    }
  }
`;

export const SYNC_USER_PROFILE_TO_ALL_CARDS = gql`
  mutation SyncUserProfileToAllCards($input: SyncUserProfileToAllCardsInput!) {
    syncUserProfileToAllCards(input: $input) {
      success
      total
      synced
      failed
    }
  }
`;
